import AdminConstants from 'constants/AdminConstants';
import ROLES from 'constants/UserRoles';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AccountingWebAPIUtils from 'utils/AccountingWebAPIUtils';
const ActionTypes = AdminConstants.ActionTypes;
export default {
    getCarrierPayouts(id, params) {
        return AccountingWebAPIUtils.getCarrierPayouts(id, params);
    },
    getPayouts(params) {
        return AccountingWebAPIUtils.getPayouts(params);
    },
    getCarrierPayout(userId, id) {
        AccountingWebAPIUtils.getCarrierPayout(userId, id);
    },
    getPayout(id) {
        AccountingWebAPIUtils.getPayout(id);
    },
    addPayouts(params) {
        AccountingWebAPIUtils.addPayouts(params);
    },
    setPayoutPaymentMethod(method, invoiceId) {
        AccountingWebAPIUtils.setPayoutPaymentMethod(method, invoiceId);
    },
    getAdminInvoices(params) {
        return AccountingWebAPIUtils.getAdminInvoices(params);
    },
    getShipperInvoices(shipperId, params) {
        return AccountingWebAPIUtils.getShipperInvoices(shipperId, params);
    },
    getInvoice(id, userType = ROLES.ADMIN) {
        AccountingWebAPIUtils.getInvoice(id, userType);
    },
    setInvoicePaymentMethod(method, invoiceId) {
        AccountingWebAPIUtils.setInvoicePaymentMethod(method, invoiceId);
    },
    markPayoutAsPaid(id) {
        AccountingWebAPIUtils.markPayoutAsPaid(id);
    },
    markInvoiceAsPaid(id) {
        AccountingWebAPIUtils.markInvoiceAsPaid(id);
    },
    approvePayout(id) {
        AccountingWebAPIUtils.approvePayout(id);
    },
    reversePayoutApproval(id) {
        AccountingWebAPIUtils.reversePayoutApproval(id);
    },
    voidPayout(id) {
        AccountingWebAPIUtils.voidPayout(id);
    },
    reversePayoutVoid(id) {
        AccountingWebAPIUtils.reversePayoutVoid(id);
    },
    setAutopayEnabled(id, enabled) {
        AccountingWebAPIUtils.setAutopayEnabled(id, enabled);
    },
    emailPayout(id, to) {
        AccountingWebAPIUtils.emailPayout(id, to);
    },
    emailInvoice(id, to, isCreditMemo) {
        AccountingWebAPIUtils.emailInvoice(id, to, isCreditMemo);
    },
    recordPaymentForPayout(id, paymentInfo) {
        AccountingWebAPIUtils.recordPaymentForPayout(id, paymentInfo);
    },
    recordPaymentForInvoice(id, paymentInfo) {
        AccountingWebAPIUtils.recordPaymentForInvoice(id, paymentInfo);
    },
    createCharge(invoice, amount, password) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.INVOICE_CHARGE_CREATE,
            invoice,
            amount,
            password,
        });
    },
    createPayment(payout, amount, password) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.PAYOUT_PAYMENT_CREATE,
            payout,
            amount,
            password,
        });
    },
    fundStripe(amount, password) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.FUND_STRIPE,
            amount,
            password,
        });
    },
    approveAccessorials(body) {
        AccountingWebAPIUtils.approveAccessorials(body);
    },
};
